/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * The subset of fields a household family member may change about themselves on the public site.
 * Email changes go through the same staged confirm-by-link flow as regular members.
 * @export
 * @interface WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
 */
export interface WebApiPublicSiteDtoUpdateFamilyMemberSelfDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoUpdateFamilyMemberSelfDto
     */
    personalNumber?: string | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoUpdateFamilyMemberSelfDto interface.
 */
export function instanceOfWebApiPublicSiteDtoUpdateFamilyMemberSelfDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoFromJSON(json: any): WebApiPublicSiteDtoUpdateFamilyMemberSelfDto {
    return WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoUpdateFamilyMemberSelfDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
    };
}

export function WebApiPublicSiteDtoUpdateFamilyMemberSelfDtoToJSON(value?: WebApiPublicSiteDtoUpdateFamilyMemberSelfDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'personalNumber': value.personalNumber,
    };
}

